import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URL } from '../models/api-url.token';
import { IMyOskEmployeeStudentIm, IMyOskStudentEmployeeVm } from '../my-osk-employee-student.model';

/** Assigning a student to an instructor or a lecturer; answers with all the student's assignments. */
@Injectable({ providedIn: 'root' })
export class MyOskEmployeeStudentService {
  private readonly baseUrl: string;

  constructor(private http: HttpClient, @Inject(API_URL) private apiUrl: string) {
    this.baseUrl = `${this.apiUrl}/MyOskEmployeeStudent`;
  }

  post(myOskEmployeeStudentIm: IMyOskEmployeeStudentIm): Observable<IMyOskStudentEmployeeVm[]> {
    const headers = this.createHeaders();
    return this.http.post<IMyOskStudentEmployeeVm[]>(this.baseUrl, myOskEmployeeStudentIm, { headers });
  }

  delete(employeeGuid: string, studentGuid: string): Observable<IMyOskStudentEmployeeVm[]> {
    const headers = this.createHeaders();
    let params = new HttpParams();
    if (employeeGuid !== undefined && employeeGuid !== null) {
      params = params.set('employeeGuid', employeeGuid.toString());
    }
    if (studentGuid !== undefined && studentGuid !== null) {
      params = params.set('studentGuid', studentGuid.toString());
    }
    return this.http.delete<IMyOskStudentEmployeeVm[]>(this.baseUrl, { headers, params });
  }

  private createHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    const token = localStorage.getItem('authToken');
    if (token) headers = headers.set('Authorization', `Bearer ${token}`);
    return headers;
  }
}
